import { render, staticRenderFns } from "./TaskLink.vue?vue&type=template&id=546f2cc4&scoped=true&"
import script from "./TaskLink.vue?vue&type=script&lang=js&"
export * from "./TaskLink.vue?vue&type=script&lang=js&"
import style0 from "./TaskLink.vue?vue&type=style&index=0&id=546f2cc4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546f2cc4",
  null
  
)

export default component.exports